<menu-toggle [active]="active" contrast="true" (click)="setActive()"></menu-toggle>

<div class="wrapper" [class.active]="active">
  <user-menu-main [user]="data" class="ms-2 me-2"></user-menu-main>
  <app-sidebar inverseMode="true"></app-sidebar>
  <div class="m-2 line"><br/></div>
  <user-menu-navigation [isSmallMenu]="false" [currency]="data?.preferences?.fiatCurrencyCode"></user-menu-navigation>
</div>
<div class="overlay" [class.active]="active" (click)="setActive(false)"></div>
